import type { InputHTMLAttributes, ReactNode } from "react";
import styles from "./Checkbox.module.css";
import { cx } from "./cx.js";

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: ReactNode;
}

/**
 * The whole control is the label, so the touch target is the row rather than a
 * 16px square — which matters when the primary device is a phone and the task
 * is ticking forty transactions.
 */
export function Checkbox({ label, className, ...rest }: CheckboxProps) {
  return (
    <label className={cx(styles.checkbox, className)}>
      <input type="checkbox" className={styles.input} {...rest} />
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
}
